// extracted by mini-css-extract-plugin
module.exports = {"headerStyle":"ClaimTicketWaiverSection_headerStyle__o7bc0"};